import { Command } from './Command';
import { ChartEngine, Layer } from '../core/ChartEngine';

export class AddLayerCommand implements Command {
  constructor(private regionId: string, private layerData: Omit<Layer, 'elements' | 'objects' | 'htmlBoxes'>) {}
  execute(engine: ChartEngine) { engine.addLayerToRegion(this.regionId, this.layerData); }
  undo(engine: ChartEngine) { engine.removeLayerFromRegion(this.regionId, this.layerData.id); }
}

export class RemoveLayerCommand implements Command {
  private savedLayer: any = null;
  constructor(private regionId: string, private layerId: string) {}
  execute(engine: ChartEngine) {
    const region = engine.getSnapshot().find(r => r.id === this.regionId);
    const layer = region?.layers.find(l => l.id === this.layerId);
    if (layer) {
      this.savedLayer = layer;
      engine.removeLayerFromRegion(this.regionId, this.layerId);
    }
  }
  undo(engine: ChartEngine) {
    if (this.savedLayer) engine.addLayerToRegion(this.regionId, this.savedLayer);
  }
}